/* eslint-disable sonarjs/todo-tag */
import axios from 'axios';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import React, { useCallback, useState } from 'react';

import LoginScreen from './components/login/LoginScreen';
import ReportsScreen from './components/reports/ReportsScreen';
import { logout } from './api/auth';
// import AdminScreen from './components/AdminScreen';
// import ReportDetailScreen from './components/ReportDetailScreen';
import NavBar from './components/NavBar';
import ProjectsScreen from './components/projects/ProjectsScreen';

import './App.css';
import UsersScreen from './components/users/UsersScreen';
import ProjectDetail from './components/projects/ProjectDetail';
import NewPasswordScreen from './components/login/NewPasswordScreen';

const ProtectedRoute = ({ authed, children }) => {
  // TODO: Pass callback here to save where the user was trying to get to, otherwise it will always go to reports
  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const ReportsRoutes = ({ userDetail }) => {
  return (
    <Routes>
      <Route index element={<ReportsScreen userDetail={userDetail} />} />
      {/* <Route path="/:id" element={<ReportDetailScreen />} /> */}
      <Route path="/*" element={<Navigate to="/reports" />} />
    </Routes>
  );
};

const ProjectsRoutes = ({ userDetail }) => {
  return (
    <Routes>
      <Route index element={<ProjectsScreen userDetail={userDetail} />} />
      <Route path="/:id" element={<ProjectDetail />} />
      <Route path="/*" element={<Navigate to="/projects" />} />
    </Routes>
  );
};

const UsersRoutes = ({ userDetail }) => {
  return (
    <Routes>
      <Route index element={<UsersScreen userDetail={userDetail} />} />
      <Route path="/*" element={<Navigate to="/users" />} />
    </Routes>
  );
};

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/reset-my-password" element={<NewPasswordScreen />} />
      <Route path="/onboard" element={<NewPasswordScreen />} />
      <Route path="/*" element={<Navigate to="/reports" />} />
    </Routes>
  );
};

const App = () => {
  const [authed, setAuthed] = useState(false);
  // const [beta, setBeta] = useState(true);
  const [userDetail, setUserDetail] = useState();

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error.response.status === 401 && !error.response.request.responseURL.endsWith('/login')) {
        setAuthed(false);
        // setBeta(true);
      }
      return Promise.reject(error);
    }
  );

  const handleLogout = useCallback(() => {
    logout().then(() => {
      setAuthed(false);
      // setBeta(true);
    });
  }, []);

  const handleLogin = useCallback((loginRes) => {
    setAuthed(true);
    setUserDetail({
      email: loginRes?.email,
      name: loginRes?.name,
      role: loginRes?.role,
      customer: loginRes?.customer,
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/users"
          element={
            <ProtectedRoute authed={authed}>
              <UsersRoutes userDetail={userDetail} />
            </ProtectedRoute>
          }
        />
        {userDetail?.role !== 'admin' && userDetail?.role !== 'installer' && (
          <Route
            path="reports/*"
            element={
              <ProtectedRoute authed={authed}>
                <ReportsRoutes userDetail={userDetail} />
              </ProtectedRoute>
            }
          />
        )}

        {userDetail?.role !== 'admin' && userDetail?.role !== 'installer' && (
          <Route
            path="/projects/*"
            element={
              <ProtectedRoute authed={authed}>
                <ProjectsRoutes userDetail={userDetail} />
              </ProtectedRoute>
            }
          />
        )}

        <Route path="/auth/*" element={<AuthRoutes />} />

        {/* <Route
          path="admin"
          element={
            <ProtectedRoute authed={authed}>
              <NavBar onLogout={handleLogout} />
              <AdminScreen />
            </ProtectedRoute>
          }
        /> */}
        <Route path="login" element={<LoginScreen onLogin={handleLogin} />} />
        {userDetail?.role !== 'admin' && userDetail?.role !== 'installer' && (
          <Route path="/*" element={<Navigate to="/reports" />} />
        )}
        {(userDetail?.role === 'admin' || userDetail?.role === 'installer') && (
          <Route path="/*" element={<Navigate to="/users" />} />
        )}
      </Routes>
      {authed && <NavBar onLogout={handleLogout} userDetail={userDetail} />}
    </BrowserRouter>
  );
};

export default App;
